<template>
  <div>
    <!-- 按钮部分 -->
    <!-- <el-button type="text" @click="open()"></el-button> -->
    <!-- dialog弹框部分 -->
    <el-dialog
      title=""
      :visible.sync="dialogFormVisible"
      :modal-append-to-body="false"
      @close="myclose"
    >
      <div class="textDiv">{{ NoEditText }}</div>
      <div class="textDiv">{{ NoEditText_time }}</div>
      <div class="Mydialog_body" v-loading="loading">
        <textarea
          type="text"
          placeholder="请输入文字或图片..."
          class="mydialog_body_text"
          v-model="text_ts"
          :class="[text_ts == null ? '' : 'NoEditText']"
        />
        <!-- 用来显示固定文字内容（发送打卡分享的时候固定的那个日期） -->
       
        <!-- 图文打卡提示文字 -->
        <div class="imageText" v-if="imageText">
          注意!请上传真实有效打卡证明，老师将不定时人工抽查，如发现滥竽充数，将取消本次打卡资格。
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="footer_box">
          <el-tooltip
            class="item"
            effect="dark"
            content="点击这里可以发表图片噢~~~"
            placement="left-start"
          >
            <i class="iconfont icon-tupian1" @click="imageStatu"></i>
          </el-tooltip>
          <el-button
            type="primary"
            @click="pushShare()"
            style="font-size: 1.375rem; width: auto"
            >发送</el-button
          >
        </div>
        <div class="update_box" v-show="imageStatus">
          <div class="sanjiao"></div>
          <UpdateImage
            @imageClose="imageStatu"
            @imgArr="childImag($event)"
            ref="upimg"
          ></UpdateImage>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import UpdateImage from "./Update_image.vue";
export default {
  name: "myDiaLog",
  props: {
    // 这个为当前发布分享所在的训练营ID 必须传！！！
    camp_id: {
      type: String,
      default: null,
    },
  },
  components: { UpdateImage },
  data() {
    return {
      // 评论模态框控制值
      dialogFormVisible: false,
      // 图片上传组件空置值
      imageStatus: false,
      // 评论框输入的内容
      text_ts: "",
      // 图片上传框选择的图片数组
      myimgArr: [],
      // 发送分享状态
      loading: false,
      // 发布分享的节流阀
      pushShareflag: true,
      // 打卡2.0新增的三个分享打卡的参数
      punch_clock: null, //打卡识别参数为1的时候为打卡分享，但是后台做了判断，所以每个分享都带上这个参数
      record_id: null, //打卡的时候需要传 做题 视频id
      less_camp_id: null, //打卡的时候需要传 打卡id 课程id
      // 用来生成不可编辑的打卡文字内容
      NoEditText: null,
      // 是否为图文模式图文模式
      imageText: false,
      NoEditText_time:null,
    };
  },
  mounted() {
    if(this.$route.query.punch_clocks != null && this.$route.query.punch_clocks != undefined && this.$route.query.punch_clocks != '' ) {
      var date = new Date();//年 getFullYear()：四位数字返回年份
      var year = date.getFullYear();  //getFullYear()代替getYear()
      var month = date.getMonth() + 1;//月 getMonth()：0 ~ 11
      var day = date.getDate();//日 getDate()：(1 ~ 31)
      var hour = date.getHours(); //时 getHours()：(0 ~ 23)
      var minute = date.getMinutes(); //分 getMinutes()： (0 ~ 59)
      var second = date.getSeconds();//秒 getSeconds()：(0 ~ 59)
      var time =  year + '-' + this.addZero(month) + '-' + this.addZero(day) + ' ' + this.addZero(hour) + ':' + this.addZero(minute) + ':' + this.addZero(second);
      this.NoEditText_time = time
    }
  },
  methods: {
    addZero(s) {
      return s < 10 ? ('0' + s) : s;
    },
    // 分享打卡内容
    pushShare() {
      if (this.pushShareflag) {
        this.pushShareflag = false;
        let formdate = new FormData();
        formdate.append("token", this.token);
        formdate.append("agency_id", this.agency_id);
        formdate.append("camp_id", this.camp_id);
        if (this.NoEditText == null ) {
          formdate.append("content", this.text_ts);
          if(this.$route.query.punch_clocks != null && this.$route.query.punch_clocks != undefined && this.$route.query.punch_clocks != '' ) {
            var date = new Date();//年 getFullYear()：四位数字返回年份
            var year = date.getFullYear();  //getFullYear()代替getYear()
            var month = date.getMonth() + 1;//月 getMonth()：0 ~ 11
            var day = date.getDate();//日 getDate()：(1 ~ 31)
            var hour = date.getHours(); //时 getHours()：(0 ~ 23)
            var minute = date.getMinutes(); //分 getMinutes()： (0 ~ 59)
            var second = date.getSeconds();//秒 getSeconds()：(0 ~ 59)
            var time =  year + '-' + this.addZero(month) + '-' + this.addZero(day) + ' ' + this.addZero(hour) + ':' + this.addZero(minute) + ':' + this.addZero(second);
            formdate.append("content", '#' + time + '完成打卡任务 #' + this.text_ts);
          }
        } else {
            formdate.append("content", this.NoEditText + this.text_ts);
        }
        if(this.$route.query.punch_clocks != null && this.$route.query.punch_clocks != undefined && this.$route.query.punch_clocks != '' ) {
          formdate.append("punch_clock", this.$route.query.punch_clocks);
        }else {
          formdate.append("punch_clock", this.punch_clock);
        }

        if(this.$route.query.record_id != null && this.$route.query.record_id != undefined && this.$route.query.record_id != '' ) {
          formdate.append("record_id", this.$route.query.record_id);
        }else {
          formdate.append("record_id", this.record_id);
        }

        if(this.$route.query.lesson_id != null && this.$route.query.lesson_id != undefined && this.$route.query.lesson_id != '' ) {
          formdate.append("less_camp_id", this.$route.query.lesson_id);
        }else {
          formdate.append("less_camp_id", this.less_camp_id);
        }
       
        this.myimgArr.forEach((item) => {
          formdate.append("files[]", item);
        });

        // 如果是图文打卡则必须上传照片
        if (this.imageText) {
          if (this.myimgArr.length == 0) {
            this.$message({
              message: "必须上传答案照片才能打卡噢",
              type: "error",
            });
            this.pushShareflag = true;
            return;
          }
        }

        this.loading = true;
        this.$axios
          .post("/pushShare", formdate)
          .then((doc) => {
            // 解开节流阀，关闭loading框
            this.pushShareflag = true;
            this.loading = false;
            if (doc.code == 200) {
              // 若发布成功初始化数据
              this.text_ts = "";
              this.myimgArr = [];
              this.$refs.upimg.imgBase64 = [];
              this.$refs.upimg.upimg = [];
              this.NoEditText = null;
              // ------初始化完成
              this.dialogFormVisible = false;
              this.$emit("addShar", doc);
              this.$message({
                message: "日记发布成功",
                type: "success",
              });
              let camp_id_sing = this.camp_id
              if(this.$route.query.lesson_id != null && this.$route.query.lesson_id != undefined && this.$route.query.lesson_id != '' ) {
                this.$router.push({path:`/Detail/study/${camp_id_sing}`, query: {active_s:'1'}})
              }else if( this.$route.query.punch_clocks == 1) {
                this.$router.push({path:`/Detail/study/${camp_id_sing}`, query: {active_s:'1'}})
              }
              
              // 如果发布日志有生成打卡日记图则触发打卡成功等元素
              if (doc.share_img.length != 0) {
                this.$emit("cardOk", doc);
              }
            } else {
              this.loading = false;
              this.$message({
                message: `${doc.data.message}`,
                type: "warning",
              });
            }
          })
          .catch((err) => {
            // 解开节流阀，关闭loading框
            console.log(err);
            this.pushShareflag = true;
            this.loading = false;
            this.$message.error("日记发布失败");
          });
      }
    },
    // 打开评论框
    open() {
      this.dialogFormVisible = true;
      console.log(this.less_camp_id);
    },
    // 上传图片组件的显隐事件
    imageStatu() {
      this.imageStatus = !this.imageStatus;
    },
    // 关闭模态框的时候获得当前评论框输入的内容
    myclose() {
      this.$emit("MyClose", this.text_ts);
      // this.pushShare();
    },
    // 获得上传图片的数组
    childImag(imgArr) {
      this.myimgArr = imgArr;
    },
  },
  watch: {
    "text_ts": (val) => {
      if (val == "") {
        return;
      }

      document.querySelector(".el-button--primary").style.cssText =
        "opacity: 1";
      document.querySelector(".mydialog_body_text").style.cssText =
        "color: #3d3d3d";
    },
  },
  computed: {
    ...mapState(["token", "agency_id"]),
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog {
  margin-top: 13vh !important;
  padding: 1.875rem;
  width: 44.9375rem;
  height: 36.4375rem;
  background: #ffffff;
  border-radius: 0.3125rem;
  // border: 1px solid red;
  // 最上方头部内容以及右上方关闭弹框按钮
  .el-dialog__header,
  .el-dialog__body,
  .el-dialog__footer {
    padding: 0;
  }
  .el-dialog__headerbtn {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: -1.125rem;
    right: -0.9375rem;
    width: 2.1875rem;
    height: 2.1875rem;
    border-radius: 50%;
    background-color: #fff;
    box-shadow: 0rem 0.0625rem 0.5rem 0rem rgba(96, 96, 96, 0.13);
    .el-icon-close:before {
      color: #bbbbbb;
      font-size: 1.3625rem;
    }
  }
  .Mydialog_body {
    position: relative;
    width: 100%;
    height: 90%;
    .mydialog_body_text {
      width: 100%;
      height: 100%;
      outline: none;
      border: none;
      font-size: 1.125rem;
      font-family: " Microsoft YaHei";
      font-weight: 400;
      color: #b4b4b4;
      resize: none;
    }
    .NoEditText {
      // text-indent: 18.5rem;
    }
    // 用来显示固定内容的
    .textDiv {
      position: absolute;
      top: 0.125rem;
      left: 0;
      font-size: 1.125rem;
      font-family: " Microsoft YaHei";
      font-weight: 400;
      // color: #b4b4b4;
    }
    .imageText {
      position: absolute;
      bottom: 0;
      left: 0;
      color: crimson;
    }
  }
  .el-dialog__body {
    height: 29.125rem;
    width: 100%;
    // border: 0.0625rem solid red;
  }
  .el-dialog__footer {
    text-align: left;
    .dialog-footer {
      width: 100%;
      // border: 0.0625rem solid black;

      .icon-tupian1 {
        font-size: 2.3125rem;
        cursor: pointer;
        .icon-tupian1:before {
          font-size: 2.5rem;
        }
      }
      .footer_box {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-content: space-between;
        justify-content: space-between;
      }
      .update_box {
        margin-left: -1.875rem;
        position: relative;
        padding: 1.0625rem 1.0625rem 1.375rem;
        width: 17.875rem;
        height: auto;
        background-color: #fff;
        box-shadow: 0rem 0.1875rem 1.125rem 0rem rgba(57, 57, 57, 0.11);
        border: 0.0625rem solid #e1e1e1;
        .sanjiao {
          position: absolute;
          top: -0.48rem;
          left: 2.4375rem;
          width: 0.9375rem;
          height: 0.9375rem;
          background-color: #fff;
          transform: rotate(45deg);
          border-top: 0.0625rem solid #e1e1e1;
          border-left: 0.0625rem solid #e1e1e1;
        }
      }
      .el-button--primary {
        // width: 5rem;
        height: 3.125rem;
        background: linear-gradient(34deg, #ff6975, #ff8e69);
        border-radius: 1.5625rem;
        border: none;
        opacity: 0.5;
        font-size: 1.375rem;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
}
</style>